/*!
 * jimdo-jquery-fullscreensize v0.0.2
 * https://github.com/Jimdo/jquery-fullscreensize
 *
 * jQuery plugin that resizes containers to fullscreen
 *
 * Copyright 2015, Jimdo GmbH
 * Released under the  license
 */
(function(jQuery, undefined) {
  'use strict';

  var $ = jQuery;
  // src/js/jqueryFullscreensize.js
  function Fullscreensize() {
    var self = this;

    if ($.isFunction(self.init)) {
      self.init.apply(self, arguments);
    }
  }

  Fullscreensize.prototype = {

    /**
     * Initialization method
     * @public
     */
    init: function(element, opts) {
      var self = this;
      var options = {};

      $.extend(options, $.fn.fullscreensize.defaults, opts);
      self.options = options;

      self.$element = $(element);
      self.resize();
    },

    /**
     * Resize the element to full screen
     * @public
     */
    resize: function() {
      var self = this;
      var $window = $(window);
      var $element = self.$element;
      var wHeight = $window.height();
      var wWidth = $window.width();
      var factor = self.options.factor;
      var elementHeight = $element.height();
      var elementWidth = $element.width();
      var roundedHeight;
      var roundedWidth;
      var heightRatio;
      var widthRatio;
      var newWidth;
      var newHeight;

      heightRatio = wHeight / elementHeight;
      widthRatio = wWidth / elementWidth;

      if (widthRatio >= heightRatio) {
        newWidth = widthRatio * elementWidth;
        newHeight = widthRatio * elementHeight;
      } else {
        newWidth = heightRatio * elementWidth;
        newHeight = heightRatio * elementHeight;
      }

      roundedHeight = Math.floor(newHeight * factor);
      roundedWidth = Math.floor(newWidth * factor);

      $element
        .height(roundedHeight)
        .width(roundedWidth);

      self._positionImageInCenter();
    },

    _positionImageInCenter: function() {
      var self = this;
      var $element = self.$element;
      var imgHeight = $element.height();
      var imgWidth = $element.width();
      var $window = $(window);
      var wHeight = $window.height();
      var wWidth = $window.width();
      var marginHeight;
      var marginWidth;

      if (imgHeight > wHeight) {
        marginHeight = (imgHeight - wHeight) / 2 * -1;
        $element.css('margin-top', marginHeight);
      }

      if (imgWidth > wWidth) {
        marginWidth = (imgWidth - wWidth) / 2 * -1;
        $element.css('margin-left', marginWidth);
      }
    }
  };

  $.fn.extend({
    fullscreensize: function(options) {
      var args = Array.prototype.slice.call(arguments);
      var method = args.shift();

      return this.each(function(index, element) {
        var instance = $.data(element, 'fullscreensize');
        if (!instance) {
          instance = new Fullscreensize(element, options);
          $.data(element, 'fullscreensize', instance);
        }

        if (method &&
          typeof method === 'string' &&
          method.charAt(0) !== '_' &&
          $.isFunction(instance[method])
        ) {
          instance[method].apply(instance, args);
        }
      });
    }
  });

  $.fn.fullscreensize.defaults = {
    factor: 1.00
  };
})(typeof require === 'function' ? require('jquery') : window.jQuery);



/*****************
 ** WEBPACK FOOTER
 ** ./~/@jimdo/jquery-fullscreensize/dist/jimdo-jquery-fullscreensize.js
 ** module id = 691
 ** module chunks = 99 237 238 240
 **/